import React from "react";
import { CodeBlock } from "react-code-blocks";
import { useAIAssessmentContext } from "../../../../Context/AIAssessmentContext/AIAssessmentContext";

const AiAssessmentQuestionText: React.FC = () => {
  const { currentStep, aiAssessmentQuestions } = useAIAssessmentContext();
  const currentQuestion = aiAssessmentQuestions[currentStep];

  const question = currentQuestion?.question;
  return (
    <div style={{ width: "100%" }}>
      <div className="white-code-block" style={{ backgroundColor: "#ffffff" }}>
        <CodeBlock
          showLineNumbers={false}
          text={question}
          language="html"
          wrapLongLines={true}
          theme={{
            backgroundColor: "#ffffff",
            textColor: "#000000",
          }}
          customStyle={{
            width: "100%",
            color: "#000000",
            backgroundColor: "#ffffff !important",
          }}
          codeBlockStyle={{
            backgroundColor: "#ffffff !important",
            color: "#000000",
          }}
        />
      </div>
    </div>
  );
};

export default AiAssessmentQuestionText;
